import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

const HomeAccordionStyle = {
  header: {
    fontWeight: "700",
    fontSize: '14px',
    color: "#707070",
    textAlign: 'left',
    marginLeft: "8px"
  },
  centerEl: {
    width: 'auto !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    marginRight: 'auto !important',
  }
};

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({

  '.MuiAccordionDetails-root': {
    padding: "0",
    overFlow: 'auto',
    minHeight: '100px',
  },
  margin: '0 12px 18px 12px',
  borderRadius: '16px',
  boxShadow:
    '-10px -10px 15px #FFFFFF, 10px 10px 10px rgba(174, 174, 192, 0.1)',
  border: '1px solid #FFFFFF',

  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none'
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    {...props}
  />
))(({ theme }) => ({
  // display:'flex',
  flexDirection: 'row-reverse',
  padding: '0 12px !important',
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({}));




export default HomeAccordionStyle;